module.exports = __webpack_public_path__ + "images/stickers/taco-money.60cee75a249b57889293.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-money.png
// module id = Gusi
// module chunks = 12